import React from "react";
import styles from "../../_css/CustomTable.module.css";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // if (totalPages <= 1) return null;
  return (
    <div className={styles.paginationRow} style={{ marginTop: 16 }}>
      <button
        className={styles.paginationBtn}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft size={18} />
      </button>
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          className={
            currentPage === i + 1
              ? `${styles.paginationBtn} ${styles.paginationBtnActive}`
              : styles.paginationBtn
          }
          onClick={() => onPageChange(i + 1)}
        >
          {i + 1 < 10 ? `0${i + 1}` : i + 1}
        </button>
      ))}
      <button
        className={styles.paginationBtn}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight size={18} />
      </button>
    </div>
  );
};

export default Pagination; 